import { HomeViewType } from '@/core/presenter/viewModel/viewTypes';
import * as ViewModel from '@/core/presenter/viewModel';
import { TOKEN_SYMBOL_ICON_PATH } from '@/consts/imgPath';

interface IProps {
  tokenAsset?: ViewModel.IAsset;
  trxBalance: string;
  tokenBalance: string;
  tokenKrw: string;
  tokenPrice: number;
  onClickViewType: (viewType: HomeViewType) => void;
}

const DoubleSProperty = ({ tokenAsset, tokenBalance, tokenKrw, tokenPrice, onClickViewType }: IProps) => {
  return (
    <li>
      <a className="property" href="#" onClick={() => onClickViewType(HomeViewType.TOKEN)}>
        <div className="left">
          <div className="symbol-area">
            <div className="img icon_margin_top">
              <img src={TOKEN_SYMBOL_ICON_PATH} alt="usdt" />
            </div>
            <div className="top asset_double_s line_height">
              <p className="fw-l body-xl asset_double_p token_title_margin_right">
                {tokenAsset?.name} <span className="asset_symbol">DBS</span>
              </p>
              <span className="body-l asset_price token_price_margin_right">
                1 DBS = {tokenPrice.toLocaleString()}원
              </span>
            </div>
          </div>
        </div>
        <div className="right">
          <div className="top">
            <p className="dbs body-xl">{tokenBalance} DBS</p>
            <span className="krw fw-b body-l">{tokenKrw} 원</span>
          </div>
        </div>
      </a>
    </li>
  );
};

export default DoubleSProperty;
